import { useTranslation } from 'react-i18next'
import { useProfileStore } from '@/reducers'
import { ProfileField } from './ProfileField'

export const PersonalInfo = () => {
  const { t } = useTranslation()
  const {
    firstName,
    lastName,
    email,
    birthDay,
    birthMonth,
    birthYear,
    address,
    phoneNumber,
  } = useProfileStore()

  return (
    <article className="grid gap-2" data-testid="container-personal-info">
      <ProfileField
        label={t('profile.personalInfo.firstNameLabel')}
        value={firstName}
      />
      <ProfileField
        label={t('profile.personalInfo.lastNameLabel')}
        value={lastName}
      />
      <ProfileField
        label={t('profile.personalInfo.emailLabel')}
        value={email}
      />
      <ProfileField
        label={t('profile.personalInfo.phoneNumberLabel')}
        value={phoneNumber}
      />
      <ProfileField
        label={t('profile.personalInfo.birthdayLabel')}
        value={`${birthDay}/${birthMonth}/${birthYear}`}
      />
      <ProfileField
        label={t('profile.personalInfo.addressLabel')}
        value={address.streetAddress1}
      />
      <ProfileField
        label={t('profile.personalInfo.provinceLabel')}
        value={address.province ?? ''}
      />
      <ProfileField
        label={t('profile.personalInfo.cityLabel')}
        value={address.city}
      />
      <ProfileField
        label={t('profile.personalInfo.postalCodeLabel')}
        value={address.postalCode}
      />
    </article>
  )
}

export default PersonalInfo
